/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Nguoi_Tao_DescInputs */

const vi_station_voice_ph_nguoi_tao_desc = /** @type {(inputs: Station_Voice_Ph_Nguoi_Tao_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tạo đơn (đọc nguyên văn)`)
};

/**

* @param {Station_Voice_Ph_Nguoi_Tao_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_nguoi_tao_desc = /** @type {((inputs?: Station_Voice_Ph_Nguoi_Tao_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Nguoi_Tao_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_nguoi_tao_desc(inputs)
});